import classes from './Button.module.scss';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Loading from '../../Loading/Loading';

let Button = forwardRef((props, forwardedRef) => {
  let {
    primary,
    secondary,
    outline,
    flat,
    invert,
    small,
    block,
    round,
    icon,
    disabled,
    children,
    className,
    dashed,
    loading,
    ...other
  } = props;

  let cn = classnames(
    classes.base,
    {
      [classes.primary]: primary,
      [classes.secondary]: secondary,
      [classes.outline]: outline,
      [classes.flat]: flat,
      [classes.invert]: invert,
      [classes.small]: small,
      [classes.block]: block,
      [classes.round]: round,
      [classes.icon]: icon,
      [classes.dashed]: dashed,
      [classes.loading]: loading
    },
    className
  );

  return (
    <button
      ref={forwardedRef}
      disabled={disabled}
      className={cn}
      type="button"
      {...other}
    >
      {loading ? (
        <React.Fragment>
          <Loading size="small" className={classes.loader} />
          <span className={classes.loaderContentWrapper}>{children}</span>
        </React.Fragment>
      ) : (
        children
      )}
    </button>
  );
});

Button.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  outline: PropTypes.bool,
  flat: PropTypes.bool,
  invert: PropTypes.bool,
  small: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  round: PropTypes.bool,
  dashed: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  className: PropTypes.string
};

Button.displayName = 'Button';

export default Button;
